<script lang="ts">
	//UI
	//Utils
	//Types
	//Props
	export let fill = "#3c68d6";
	//Constants
	//Variables
	//Functions
	//Do

</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 13.761 13.93">
	<defs>
		<clipPath id="cnowpkpr2a">
			<path
				data-name="사각형 6431"
				style={`fill:${fill}`}
				d="M0 0h13.761v13.93H0z" />
		</clipPath>
	</defs>
	<g>
		<g style="clip-path:url(#cnowpkpr2a)">
			<path
				d="M21.2 1.232a2.753 2.753 0 0 0-3.81-.777l-5.196 3.436a2.75 2.75 0 1 0 3.033 4.587l1.81-1.2a.28.28 0 0 0-.309-.467l-1.81 1.2A2.19 2.19 0 1 1 12.5 4.358L17.7.922a2.19 2.19 0 0 1 2.416 3.653l-1.456.965a.28.28 0 0 0 .1.508.274.274 0 0 0 .209-.041l1.456-.965a2.75 2.75 0 0 0 .777-3.81"
				transform="translate(-7.896)"
				style={`fill:${fill}`} />
			<path
				d="m6.429 18.31-1.943 1.285a.28.28 0 0 0 .309.467l1.942-1.285a2.19 2.19 0 0 1 2.416 3.653l-5.195 3.436a2.19 2.19 0 1 1-2.416-3.653l1.487-.984a.28.28 0 0 0-.309-.467l-1.487.984a2.749 2.749 0 0 0 .967 4.987 2.765 2.765 0 0 0 .555.057 2.733 2.733 0 0 0 1.511-.457L9.462 22.9a2.75 2.75 0 0 0-3.033-4.59"
				transform="translate(0 -12.86)"
				style={`fill:${fill}`} />
		</g>
	</g>
</svg>

<style lang="scss">
</style>
